(() => {
  if (window.InkyboxRelatedCatalog) return;

  const sourceMarkup = new Map();
  const cardMarkup = new Map();

  function parseSource(root) {
    const source = root?.matches?.('[data-related-metafield-source]')
      ? root
      : root?.querySelector?.('[data-related-metafield-source]');
    if (!source) return { anchorProductId: '', anchorHandle: '', candidates: [] };

    const seen = new Set();
    const candidates = [...source.querySelectorAll('[data-related-metafield-candidate]')]
      .map((item, rank) => ({
        productId: String(item.dataset.productId || ''),
        handle: String(item.dataset.productHandle || ''),
        rank,
        source: 'metafield',
        trackingUrl: '',
      }))
      .filter((candidate) => {
        if (!candidate.productId || !candidate.handle || seen.has(candidate.productId)) return false;
        seen.add(candidate.productId);
        return true;
      });

    return {
      anchorProductId: String(source.dataset.anchorProductId || ''),
      anchorHandle: String(source.dataset.anchorProductHandle || ''),
      candidates,
    };
  }

  async function fetchSource(handle) {
    if (!handle) return { anchorProductId: '', anchorHandle: '', candidates: [] };
    if (!sourceMarkup.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      sourceMarkup.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}?view=related-products`, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      }).then((response) => response.ok ? response.text() : ''));
    }
    const html = await sourceMarkup.get(handle);
    if (!html) return { anchorProductId: '', anchorHandle: handle, candidates: [] };
    return parseSource(new DOMParser().parseFromString(html, 'text/html'));
  }

  async function shopifyFallback(productId) {
    if (!productId) return [];
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(`${root}recommendations/products.json`, window.location.origin);
    url.searchParams.set('product_id', productId);
    url.searchParams.set('limit', '20');
    url.searchParams.set('intent', 'related');
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) return [];
    const data = await response.json();
    return (Array.isArray(data?.products) ? data.products : [])
      .filter((product) => product?.id && product?.handle && product.available !== false)
      .map((product, rank) => ({
        productId: String(product.id),
        handle: product.handle,
        rank,
        source: 'shopify',
        trackingUrl: product.url || '',
      }));
  }

  async function resolve({ sourceElement, productId, handle } = {}) {
    let result = sourceElement ? parseSource(sourceElement) : await fetchSource(handle).catch(() => ({
      anchorProductId: '',
      anchorHandle: handle || '',
      candidates: [],
    }));
    const anchorProductId = result.anchorProductId || String(productId || '');
    const anchorHandle = result.anchorHandle || String(handle || '');
    if (!result.candidates.length) {
      result = {
        anchorProductId,
        anchorHandle,
        candidates: await shopifyFallback(anchorProductId).catch(() => []),
      };
    }
    return result;
  }

  async function fetchCardMarkup(handle) {
    if (!cardMarkup.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      cardMarkup.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}?view=recently-viewed`, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      }).then((response) => response.ok ? response.text() : ''));
    }
    return cardMarkup.get(handle);
  }

  async function render(candidate, namespace = 'related-products') {
    const html = await fetchCardMarkup(candidate.handle);
    if (!html) return null;
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const card = documentFragment.querySelector('[data-recently-viewed-card]');
    if (!card) return null;
    card.querySelectorAll('[id], [aria-labelledby], [aria-describedby], [aria-controls], [for]').forEach((element) => {
      ['id', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'for'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        if (value?.includes('recently-viewed-products')) {
          element.setAttribute(attribute, value.replaceAll('recently-viewed-products', namespace));
        }
      });
    });
    card.dataset.productId = candidate.productId;
    card.dataset.recommendationSource = candidate.source;
    card.dataset.recommendationRank = String(candidate.rank);
    if (candidate.trackingUrl) {
      card.querySelectorAll('a[href]').forEach((link) => {
        if (link.getAttribute('href')?.includes(`/products/${candidate.handle}`)) {
          link.setAttribute('href', candidate.trackingUrl);
        }
      });
    }
    return card;
  }

  window.InkyboxRelatedCatalog = { parseSource, resolve, render };
})();
